import cn from 'classnames'
import { configuration } from 'mmfintech-backend-api'
import { getCountryImageUrl } from 'mmfintech-commons'

import styles from './FlagIcon.module.scss'

interface FlagIconProps {
  countryCode?: string
  className?: string
  circle?: boolean
}

const FlagIcon = ({ countryCode, circle = false, className = '' }: FlagIconProps) => {
  return (
    <span
      data-test={`flag-icon-${countryCode}`}
      className={cn(styles['flag-icon-wrapper'], 'flag-icon', className, { [styles.circle]: circle })}
    >
      <img src={`${configuration.getBaseUrl()}${getCountryImageUrl(countryCode, 'svg')}`} alt='' />
    </span>
  )
}

export default FlagIcon
